import * as actionTypes from '../actions/actionTypes';
import {get} from '../../services/store';

const DEFAULT_STATE = () => ({
    loggedIn: !!get('token'),
    profile: {
        loading: false,
    },
});

const userReducer = (state = DEFAULT_STATE(), action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE': {
            return DEFAULT_STATE();
        }
        case actionTypes.PROFILE_FETCH: {
            return {
                ...state,
                profile: {
                    ...state.profile,
                    loading: true,
                },
            };
        }
        case actionTypes.PROFILE_FETCH_FAILED: {
            return {
                ...state,
                profile: {
                    ...state.profile,
                    loading: false,
                },
            };
        }
        case actionTypes.PROFILE_FETCH_SUCCESS: {
            return {
                ...state,
                profile: {
                    ...action.payload,
                    loading: false,
                },
            };
        }
        case actionTypes.LOG_OUT: {
            return {
                ...state,
                loggedIn: false,
            };
        }
        case actionTypes.LOG_IN_SUCCESS: {
            return {
                ...state,
                loggedIn: true,
            };
        }
        default: {
            return state;
        }
    }
};

export default userReducer;



// WEBPACK FOOTER //
// /src/redux/reducers/userReducer.js